define('plugin/multiple-booking/view/MultipleBookingButtonView',['require','marionette'],function (require) {

    var Marionette = require('marionette');

    /**
     * Multiple booking button view
     *
     * @class MultipleBookingButtonView
     */
    return Marionette.ItemView.extend({

        template: '#multiple_booking_button_view',

        ui: {
            'bookBtn': '#sb_multiple_booking_btn'
        },
        triggers: {
            'click @ui.bookBtn': 'submit'
        }

    });

});
